import Api from '@/api/Api';

import { useAccessStore } from '@/stores/access';
import { useUserStore } from '@/stores/user';
import { useBaseStationsStore } from '@/stores/baseStations';
import { useSessionStore } from '@/stores/session';

import { applyUiTheme } from '@/api/uiThemes';


const profileGetDetails = () => {
	Api.profileGetDetails(data => {
		useAccessStore().update(
			data.access.allowReadOnlyUnauthorizedAccess,
			data.access.showMountpointsForUnauthorizedUsers,
			data.access.telegramAlertsEnabled,
			data.access.smtpReady,
		);
		useUserStore().update(
			data.profile.role,
			data.profile.enabled,
			data.settingsSpecialModeActive === true,
		);
		useSessionStore().updateProjectTitle(data.projectTitle);
		applyUiTheme(data.uiTheme || window.__UI_THEME__ || '');
	})
};

const getToken = (username, password, successHandler, errorHandler) => {
	const userStore = useUserStore()
	userStore.logout()
	Api.getToken(username, password, response => {
		userStore.login(response.data);
		profileGetDetails();
		useBaseStationsStore().updateBSData();
		successHandler(response.data.redirect_name);
	}, errorHandler);
};

const logout = () => {
	const userStore = useUserStore()
	const baseStationsStore = useBaseStationsStore();
	Api.logout(userStore.token);
	userStore.logout();
	baseStationsStore.updateBSData();
	baseStationsStore.clear();
}

export default {
	profileGetDetails,
	getToken,
	logout,
};
